'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HoldsIcon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function HoldsIcon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-holds ' + className,
      width: width, height: height,
      viewBox: '0 0 48 48' },
    _react2.default.createElement(
      'defs',
      null,
      _react2.default.createElement('polygon', { id: 'holds-a', points: '27.243 37.779 24.414 34.95 23 36.364 25.828 39.193 27.243 40.607 33.606 34.243 32.192 32.829' })
    ),
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { fill: color, d: 'M8.8569,16.9219 C8.8569,16.8279 8.9029,16.7349 8.9959,16.6409 C9.0879,16.5469 9.1799,16.4999 9.2729,16.4999 L23.9419,16.4999 C24.0339,16.4999 24.1269,16.5469 24.2189,16.6409 C24.3109,16.7349 24.3569,16.8279 24.3569,16.9219 L24.3569,18.3279 C24.3569,18.4219 24.3109,18.5159 24.2189,18.6089 C24.1269,18.7029 24.0339,18.7499 23.9419,18.7499 L9.2729,18.7499 C9.1799,18.7499 9.0879,18.7029 8.9959,18.6089 C8.9029,18.5159 8.8569,18.4219 8.8569,18.3279 L8.8569,16.9219 Z M8.8569,12.4219 C8.8569,12.3279 8.9029,12.2349 8.9959,12.1409 C9.0879,12.0469 9.1799,11.9999 9.2729,11.9999 L23.9419,11.9999 C24.0339,11.9999 24.1269,12.0469 24.2189,12.1409 C24.3109,12.2349 24.3569,12.3279 24.3569,12.4219 L24.3569,13.8279 C24.3569,13.9219 24.3109,14.0159 24.2189,14.1089 C24.1269,14.2029 24.0339,14.2499 23.9419,14.2499 L9.2729,14.2499 C9.1799,14.2499 9.0879,14.2029 8.9959,14.1089 C8.9029,14.0159 8.8569,13.9219 8.8569,13.8279 L8.8569,12.4219 Z M13.4799,34.4999 L6.6429,34.4999 C6.0429,34.4999 5.5239,34.2769 5.0859,33.8319 C4.6479,33.3869 4.4289,32.8599 4.4289,32.2499 C4.4289,31.6409 4.6479,31.1129 5.0859,30.6679 C5.5239,30.2229 6.0429,29.9999 6.6429,29.9999 L14.5419,29.9999 L15.3589,26.5409 C15.5719,25.6379 16.3779,24.9999 17.3059,24.9999 L30.9999,24.9999 L30.9999,4.6879 C30.9999,4.2189 30.8379,3.8199 30.5159,3.4919 C30.1929,3.1639 29.8009,2.9999 29.3389,2.9999 L6.6429,2.9999 C4.7979,2.9999 3.2289,3.6559 1.9379,4.9689 C0.6459,6.2809 -0.0001,7.8749 -0.0001,9.7499 L-0.0001,32.2499 C-0.0001,34.1249 0.6459,35.7189 1.9379,37.0309 C3.2289,38.3439 4.7979,38.9999 6.6429,38.9999 L12.4169,38.9999 L13.4799,34.4999 Z' }),
      _react2.default.createElement('path', { fill: color, d: 'M40.7334,42 L43.2474,31.316 L45.7394,42 L40.7334,42 Z M38.2084,44 L15.2624,44 L18.7914,29 L18.7924,29 L39.0004,29 L41.7374,29 L38.2084,44 Z M47.6874,41.546 L44.6544,28.546 C44.4414,27.636 43.6414,27 42.7064,27 L41.7374,27 L39.0004,27 L18.7924,27 C17.8594,27 17.0594,27.634 16.8444,28.542 L13.3154,43.543 C13.2804,43.693 13.2624,43.846 13.2624,44 C13.2624,45.103 14.1594,46 15.2624,46 L38.2084,46 C39.1404,46 39.9414,45.366 40.1554,44.458 L40.2634,44 L45.7394,44 C46.8424,44 47.7394,43.103 47.7394,42 C47.7394,41.849 47.7224,41.697 47.6874,41.546 Z' }),
      _react2.default.createElement('polygon', { fill: color, points: '25.829 39.192 23 36.363 24.414 34.949 27.243 37.778 32.193 32.828 33.607 34.242 27.243 40.606' })
    )
  );
}

HoldsIcon.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/HoldsIcon/HoldsIcon.js
// module id = 247
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16